import { OnInit, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { UiService } from '../ui/ui.service';
import { ReplaySubject } from 'rxjs';
var HOME_PAGE_BOTH_PARTS_WIDTH = 930;
var HomePageComponent = /** @class */ (function () {
    function HomePageComponent(ui, changeDetectorRef) {
        this.ui = ui;
        this.changeDetectorRef = changeDetectorRef;
        this.mapPaddings = {
            left: 300 + 60,
            right: 16 + 8
        };
        this.destroyed$ = new ReplaySubject(1);
    }
    HomePageComponent.prototype.ngOnInit = function () {
    };
    HomePageComponent.prototype.ngAfterViewInit = function () {
        this.ui.whitened$.next(false);
    };
    HomePageComponent.prototype.ngOnDestroy = function () {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    };
    return HomePageComponent;
}());
export { HomePageComponent };
var HomePageDisplayMode;
(function (HomePageDisplayMode) {
    HomePageDisplayMode["MAP"] = "map";
    HomePageDisplayMode["NEWS"] = "news";
    HomePageDisplayMode["BOTH"] = "both";
})(HomePageDisplayMode || (HomePageDisplayMode = {}));
//# sourceMappingURL=home-page.component.js.map